import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const USERNAME_RE = /^[a-z0-9._-]{3,32}$/i;

/**
 * Step 1 of the kiosk PIN flow: capture username. We keep the keyboard simple
 * (system text input) since usernames are alphanumeric and the iPad's on-screen
 * keyboard is the natural affordance. PIN is the keypad-driven step.
 */
export function KioskUsername() {
  const [username, setUsername] = useState('');
  const navigate = useNavigate();

  function go() {
    if (!USERNAME_RE.test(username)) return;
    navigate(`/kiosk/pin?u=${encodeURIComponent(username)}`);
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-6">
      <img src="/favicon.svg" alt="Qargo Coffee" className="h-14 w-14" />
      <h2 className="text-2xl font-semibold">Start shift</h2>
      <p className="text-sm text-muted-foreground">Enter your username</p>
      <input
        type="text"
        autoComplete="username"
        autoFocus
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') go();
        }}
        className="w-72 h-14 rounded-xl border border-border bg-card px-4 text-lg"
        placeholder="username"
      />
      <button
        type="button"
        onClick={go}
        disabled={!USERNAME_RE.test(username)}
        className="w-72 h-12 rounded-xl bg-primary text-primary-foreground font-medium disabled:opacity-60"
      >
        Continue
      </button>
      <Link to="/lock" className="text-xs text-muted-foreground underline underline-offset-4">
        ← Back
      </Link>
    </div>
  );
}
